import { AuthState, LoginCredentials } from "@/types";
import { createContext } from "react";

interface AuthContextData extends AuthState {
  signIn: (credentials: LoginCredentials) => Promise<void>;
  signOut: () => void;
  refreshToken: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextData>(
  {} as AuthContextData
);
